var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('div',{attrs:{"className":"animated"}},[(_vm.userData)?_c('user-form',{attrs:{"formData":_vm.userData}}):_vm._e()],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }